import React, { useState } from "react";
import { Button, CircularProgress, Snackbar, Alert, Dialog, DialogTitle, DialogActions, DialogContent, Typography } from "@mui/material";
import { makeSupportRequestForVersion } from "../../Services/VersionsApi";

const BuyPlanButton = ({ planeId, type = "request_plane", message = "سي" }) => {
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, success: false, message: "" });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleConfirm = async () => {
    setConfirmOpen(false);
    setLoading(true);
    try {
      const res = await makeSupportRequestForVersion(planeId, type, message);
      setSnackbar({ open: true, success: true, message: "تم إرسال طلب الاشتراك بنجاح ✅" });
      console.log("✅ Response:", res.data);
    } catch (err) {
      console.error("❌ Error:", err);
      setSnackbar({ open: true, success: false, message: "حدث خطأ أثناء إرسال الطلب" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* زر الشراء */}
      {/* <Button
        variant="contained"
        fullWidth
        size="large"
        disabled={loading}
        onClick={() => setConfirmOpen(true)}
        sx={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          borderRadius: "16px",
          py: 2,
          fontSize: "1.1rem",
          fontWeight: "bold",
          textTransform: "none",
          boxShadow: "0 8px 25px rgba(102, 126, 234, 0.3)",
          "&:hover": {
            background: "linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)",
            transform: "translateY(-2px)",
            boxShadow: "0 12px 35px rgba(102, 126, 234, 0.4)",
          },
        }}
      >
        {loading ? <CircularProgress size={26} color="inherit" /> : "اشترك الآن"}
      </Button> */}

      {/* نافذة تأكيد */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>تأكيد الاشتراك</DialogTitle>
        <DialogContent>
          <Typography>هل أنت متأكد أنك تريد الاشتراك في هذه الباقة؟</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>إلغاء</Button>
          <Button onClick={handleConfirm} variant="contained" color="primary">
            تأكيد
          </Button>
        </DialogActions>
      </Dialog>

      {/* إشعار النجاح أو الفشل */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert severity={snackbar.success ? "success" : "error"} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default BuyPlanButton;
